import { TRACK_IDS } from "../../../analytics/trackIds";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import localizationStrings from "../../../statics/localization";
import PlayerExitIcon from "../../../assets/icons/svg/PlayerExitIcon";
import moment, { months } from "moment";
import { isSafari } from "react-device-detect";

const ExitConfirmation = ({ player, onConfirm, onCancel }) => {
  const cancelButton = useRef(null);
  const confirmButton = useRef(null);
  useEffect(() => {
    cancelButton.current.focus();
  }, []);
  return createPortal(
    <div className="atlas-player-exit" role="dialog" aria-modal="true"
      aria-label={localizationStrings.exitPlayerText}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          event.preventDefault();
          event.stopPropagation();
          onCancel();
        } else if (event.key === "Tab") {
          event.preventDefault();
          (document.activeElement === cancelButton.current
            ? confirmButton.current : cancelButton.current).focus();
        }
      }}>
      <div className="atlas-player-exit-card">
        <p>{localizationStrings.exitPlayerText}</p>
        <div className="atlas-player-exit-actions">
          <button type="button" ref={cancelButton} onClick={onCancel}>{localizationStrings.no}</button>
          <button type="button" ref={confirmButton} onClick={onConfirm}>{localizationStrings.yes}</button>
        </div>
      </div>
    </div>, player.el()
  );
};

const ExitButton = ({
  player,
  goBack,
  showExitNotification,
  vod,
  selectedSeason,
  selectedEpisode,
  isCutvVod
}) => {
  const [showExitContainer, setShowExitContainer] = useState(false);
  const wasPlaying = useRef(false);
  const backButton = useRef(null);
  const restoreFocus = useRef(false);
  useEffect(() => {
    if (!showExitContainer && restoreFocus.current && backButton.current) {
      backButton.current.focus();
      restoreFocus.current = false;
    }
  }, [showExitContainer]);
  const cuEpisodeInfo = isCutvVod
    ? isSafari
      ? moment(selectedEpisode?.onlinetime, "YYYY-MM-DDTHH:mm:ssZ").format(
          "D MMMM"
        )
      : `${moment(selectedEpisode?.onlinetime).date()} ${months(
          moment(selectedEpisode?.onlinetime).month()
        )}`
    : null;
  const clickConfirm = () => {
    setShowExitContainer(false);
    showExitNotification(false);
    goBack();
  };

  const clickNotConfirm = () => {
    restoreFocus.current = true;
    setShowExitContainer(false);
    showExitNotification(false);
    if (wasPlaying.current && player && !player.isDisposed()) {
      const result = player.play();
      if (result && result.catch) result.catch(() => {});
    }
  };

  return (
    <>
      {showExitContainer ? (
        <ExitConfirmation player={player} onConfirm={clickConfirm} onCancel={clickNotConfirm} />
      ) : (
        <div className="exit-and-info-wrapper">
          <button
            data-track-id={TRACK_IDS.PLAYER_EXIT}
            className="exit-button"
            type="button"
            aria-label={localizationStrings.back}
            ref={backButton}
            onClick={() => {
              wasPlaying.current = !player.paused();
              setShowExitContainer(true);
              showExitNotification(true);
              player.pause();
            }}
          >
            <PlayerExitIcon />
          </button>
          <div className="content-info-box">
            <div className="content-title">{vod?.title}</div>
            {selectedSeason && selectedEpisode ? (
              <>
                {isCutvVod ? (
                  <div className="episode-info">{cuEpisodeInfo}</div>
                ) : (
                  <div className="episode-info">
                    {selectedEpisode?.episodeNo
                      ? `${localizationStrings.episode} ${selectedEpisode?.episodeNo}`
                      : null}
                    {selectedEpisode?.episodeNo && selectedEpisode?.seasonNo ? (
                      <span>{" • "}</span>
                    ) : null}
                    {selectedSeason?.seasonNo
                      ? `${localizationStrings.season} ${selectedSeason?.seasonNo}`
                      : null}
                    {/* {(selectedSeason?.seriesseason ||
                      selectedEpisode?.seasonNo) &&
                    selectedEpisode?.title ? (
                      <span>{" • "}</span>
                    ) : (
                      ""
                    )}
                    {selectedEpisode?.title} */}
                  </div>
                )}
              </>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};

export default ExitButton;
